import api from './client';

export const appAuthApi = {
  login: (loginId, password) =>
    api.post('/api/app-auth/login', { login_id: loginId, password }),
  logout: () => api.post('/api/app-auth/logout', {}),
  me: () => api.get('/api/app-auth/me'),
};
